import Button, { ButtonInterface } from "@components/Button";
import styled from "@emotion/styled";
import Link, { LinkProps } from "next/link";
import React from "react";

interface ILinkButtonProps {
  href?: LinkProps["href"];
  buttonProps?: ButtonInterface;
  LinkProps?: LinkProps;
  children?: React.ReactNode;
}

export default function LinkButton({
  buttonProps,
  LinkProps,
  href,
  children,
}: ILinkButtonProps) {
  const propsForLink = {
    href: href ?? "",
    ...LinkProps,
  };

  return (
    <Link {...propsForLink} passHref>
      <a>
        <ButtonExt thin_button {...buttonProps}>
          {children}
        </ButtonExt>
      </a>
    </Link>
  );
}

const ButtonExt = styled(Button)`
  padding: 1px 10px 1px 16px;

  &:hover {
    text-decoration: underline;
  }
`;
